import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

import pxToRem from '../../utils/pxToRem'
import ButtonVariantEnum from '../../enums/ButtonVariant'

const buttonsVariants = {
  [ButtonVariantEnum.primary]: css`
    border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.unique.transparent}`};
    background-color: ${({ theme }) => theme.colors.primary.midnightBlue};
    color: ${({ theme }) => theme.colors.unique.white};

    &:not(:disabled):hover {
      border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.primary.midnightBlueHovering}`};
      background-color: ${({ theme }) => theme.colors.primary.midnightBlueHovering};
    }
  `,
  [ButtonVariantEnum.secondary]: css`
    border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.primary.midnightBlue}`};
    background-color: ${({ theme }) => theme.colors.unique.white};
    color: ${({ theme }) => theme.colors.primary.midnightBlue};

    &:not(:disabled):hover {
      border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.primary.midnightBlue}`};
      background-color: ${({ theme }) => theme.colors.primary.midnightBlue};
      color: ${({ theme }) => theme.colors.unique.white};
    }
  `,
  [ButtonVariantEnum.tertiary]: css`
    border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.unique.transparent}`};
    background-color: ${({ theme }) => theme.colors.unique.transparent};
    color: ${({ theme }) => theme.colors.primary.midnightBlue};

    &:not(:disabled):hover {
      background-color: ${({ theme }) => theme.colors.main.grayLight};
    }
  `,
  [ButtonVariantEnum.quaternary]: css`
    border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.primary.blue}`};
    padding: ${pxToRem(15.5)} ${pxToRem(25)};
    background-color: ${({ theme }) => theme.colors.unique.white};

    &:disabled {
      border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.primary.grey}`};
      background-color: ${({ theme }) => theme.colors.unique.white};
      color: ${({ theme }) => theme.colors.unique.white};
    }

    &:hover {
      border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.unique.transparent}`};
      color: ${({ theme }) => theme.colors.unique.white};
      background-color: ${({ disabled, theme }) => {
      if (disabled) {
        return 'none'
      }
      return theme.colors.unique.black
    }};
    }
  `,
  [ButtonVariantEnum.quinary]: css`
    margin: ${pxToRem(15)} ${pxToRem(4)};
    border: ${({ theme }) =>
      `${pxToRem(1)} solid ${theme.colors.unique.transparent}`};
    border-radius: 0;
    padding: ${pxToRem(5)} 0;
    background-color: ${({ theme }) => theme.colors.unique.transparent};
  `,
}

export const StyledButtonComponent = css`
  ${({ iconOnly, theme }) =>
    iconOnly
      ? css`
          min-width: ${pxToRem(42)};
          height: ${pxToRem(42)};
          padding: 0;
          font-size: 0;
        `
      : css`
          gap: ${pxToRem(17)};
          min-height: ${pxToRem(42)};
          padding: ${pxToRem(5)} ${pxToRem(25)};
          font-size: ${theme.fonts.sizes.button};
          font-weight: ${theme.fonts.weight.medium};
          text-align: center;
        `}
  
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.pill};
  transition: ${({ theme }) => theme.transitions.default};
  cursor: ${({ disabled }) => !disabled && 'pointer'};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  svg {
    min-width: ${pxToRem(7)};
    fill: currentColor;
  }

  ${({ $variant }) =>
    ($variant && buttonsVariants[$variant]) ||
    buttonsVariants[ButtonVariantEnum.tertiary]}
`

export const StyledButton = styled.button`
  ${StyledButtonComponent};
`

export const StyledInternalLink = styled(Link)`
  ${StyledButtonComponent};
`

export const StyledExternalLink = styled.a`
  ${StyledButtonComponent};
`